module.exports = __webpack_public_path__ + "img/logo-title.7ad08ae5.svg";